import React from 'react';
import Spinner from 'react-spinkit';
import { defineMessages, FormattedMessage } from '@kyruus/intl';
import { bool } from 'prop-types';

const messages = defineMessages({
  ariaLoading: {
    id: 'aria.label.loading',
    description: 'Accessibility label for the loading spinner',
    defaultMessage: 'Loading {message}'
  }
});

export default function LoadingOverlay({ loading, filterDrawerOpen = false }) {
  return (
    <>
      <span className="sr-only" aria-live="polite">
        <FormattedMessage
          {...messages.ariaLoading}
          values={{ message: loading === false ? 'Complete' : null }}
        />
      </span>
      {loading === true && (
        <div
          className={`loading-overlay ${
            filterDrawerOpen ? 'filter-drawer-open' : ''
          }`}
        >
          <div className="spinner-container">
            <Spinner name="wandering-cubes" fadeIn={'none'} />
          </div>
        </div>
      )}
    </>
  );
}

LoadingOverlay.propTypes = {
  loading: bool.isRequired
};
